import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NotFoundComponent } from "../../components/info/NotFoundComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const NotFoundPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Страница не найдена — AviaMarket24</title>
      </Helmet>
      <NotFoundComponent />
    </>
  );
};

export default withTranslation()(NotFoundPage);
